<template>
  <div style="margin: 2% 3% 0% 3%;">
    <v-card color="border" elevation="3" style="padding: 20px;">
      <v-expansion-panels v-model="navigation.searchVisible">
        <v-expansion-panel value="searchVisible">
          <v-expansion-panel-title>
            <p style="font-size: large;">Búsqueda de tokens</p>
            <template v-slot:actions>
              <v-icon icon="mdi-magnify"></v-icon>
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>        
            <br>
            <div style="display: flex;">
              <div style="width: 49.5%; margin-right: 0.5%;">
                <v-tooltip open-delay="2000" location="top">
                  <template v-slot:activator="{ props }">
                    <v-text-field 
                      v-bind="props"
                      v-model="input.tokenID" 
                      :append-inner-icon="input.tokenID ? 'mdi-barcode-off' : 'mdi-barcode'" 
                      @click:append-inner="input.tokenID = null" 
                      label="Buscar por identificador interno" 
                      variant="solo-filled" 
                      density="compact"
                    ></v-text-field>
                  </template>
                  <span style="max-width: 400px; display: block;">El identificador interno es el consecutivo único del token que se genera de forma automática a nivel interno. Si se coloca un identificador interno, se buscará el único token que coincida con el mismo. Al presionar el ícono de la derecha se limpia el identificador interno colocado</span>
                </v-tooltip>
              </div>
              <div style="width: 49.5%; margin-left: 0.5%;">
                <v-tooltip open-delay="2000" location="top">
                  <template v-slot:activator="{ props }">
                    <v-autocomplete 
                      v-bind="props"
                      v-model="input.tokenState" 
                      :append-inner-icon="input.tokenState == null ? 'mdi-sync' : 'mdi-sync-off'" 
                      @click:append-inner="input.tokenState = null; this.blurInput('tokenState')"  
                      :items="['Token activo', 'Token inactivo']" 
                      multiple
                      chips
                      closable-chips
                      color="primary"
                      ref="tokenState"
                      label="Filtrar por estado del traslado" 
                      placeholder="Todos los estados del traslado"
                      variant="solo-filled" 
                      density="compact"
                    ></v-autocomplete>
                  </template>
                  <span style="max-width: 400px; display: block;">El estado del traslado es el momento en el tiempo en el que se encuentra un traslado. Este espacio permite selección múltiple para filtrar por varios estados del traslado en paralelo. Si ningún estado del traslado es seleccionado, se buscarán todas los traslados de producto sin importar el estado del traslado. Al presionar el ícono de la derecha se limpian los estados del traslado seleccionados</span>
                </v-tooltip>
              </div>
            </div>
            <br><br>
            <div v-if="loader.selectBillOnBillsView" style="text-align: center;">
              <br>
              <v-progress-circular color="primary" indeterminate></v-progress-circular>
              <br><br>
            </div>
            <div v-else>
              <v-btn @click="selectBillOnBillsView()" :disabled="loader.selectLocalityIDAndLocalityNameByLocalityIsActive || loader.selectAgentByAgentLocalityIDAndByAgentIsActive || loader.selectProductBasicBasicInformationForBillsView || loader.selectBillOnBillsView" dark block height="38" color="primary">
                <h3>BUSCAR</h3>
                <v-icon style="margin-left: 20px;" dark right>mdi-magnify</v-icon>
              </v-btn>
              <br>
              <v-tooltip open-delay="2000" location="top">
                <template v-slot:activator="{ props }">
                  <v-btn 
                    v-bind="props" 
                    @click="setDefaultValues()" 
                    :disabled="loader.selectLocalityIDAndLocalityNameByLocalityIsActive || loader.selectAgentByAgentLocalityIDAndByAgentIsActive || loader.selectProductBasicBasicInformationForBillsView || loader.selectBillOnBillsView" 
                    dark 
                    block 
                    height="38" 
                    color="#b3b3b3"
                  >
                    <h3>LIMPIAR BÚSQUEDA</h3>
                    <v-icon style="margin-left: 20px;" dark right>mdi-backspace</v-icon>
                  </v-btn>
                </template>
                <span style="max-width: 400px; display: block;">Al presionar este botón, se limpiarán los resultados de la búsqueda actual, y se reestablecerán todos los filtros de búsqueda a sus valores por defecto</span>
              </v-tooltip>
            </div>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
    <v-card color="border" elevation="3" style="padding: 20px; max-height: 700px; overflow-y: auto;">
      <v-data-table-virtual :headers="display.tokenHeaders" :items="display.token">
        <template v-slot:item.agentName="{ item }">
          <v-chip :color="item.agentColor" variant="flat">
            <p :style="{color: item.agentFontColor}">{{ item.agentName }}</p>
          </v-chip>
        </template>
        <template v-slot:item.tokenCreationDatetime="{ item }">
          <p>{{ $generalFunctions.default.methods.parseDatetimeToDDMMYYYHHMMSS(item.tokenCreationDatetime) }}</p>
        </template>
        <template v-slot:item.tokenExpirationDatetime="{ item }">
          <p>{{ item.tokenExpirationDatetime ? $generalFunctions.default.methods.parseDatetimeToDDMMYYYHHMMSS(item.tokenExpirationDatetime) : 'Sin fecha de expiración'}}</p>
        </template>
        <template v-slot:item.tokenUseAmount="{ item }">
          <p>{{ item.tokenUseAmount || 'Sin límite de usos' }}</p>
        </template>
        <template v-slot:item.tokenRemainingUseAmount="{ item }">
          <p>{{ item.tokenRemainingUseAmount || 'Sin límite de usos' }}</p>
        </template>
      </v-data-table-virtual>  
    </v-card>
  </div>
</template>

<style scoped>
</style>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TokenView',

  inject: ['$generalFunctions'],

  data: () => ({
    input: 
    {
      tokenID: null,
      tokenState: null,
      startDate: null,
      endDate: null
    },

    display: 
    {
      token: [],
      tokenHeaders: 
      [
        {key: 'tokenID', title: 'ID', sortable: false},
        {key: 'tokenValue', title: 'VALOR', sortable: false},
        {key: 'tokenType', title: 'TIPO', sortable: false},
        {key: 'agentName', title: 'GENERADO POR', sortable: false},
        {key: 'tokenCreationDatetime', title: 'GENERADO EL', sortable: false},
        {key: 'tokenExpirationDatetime', title: 'EXPIRA EL', sortable: false},
        {key: 'tokenUseAmount', title: 'USOS ORIGINALES', sortable: false},
        {key: 'tokenRemainingUseAmount', title: 'USOS RESTANTES', sortable: false}
      ]
    },

    navigation: {},

    loader:
    {
      selectTokenFromTokenView: false
    },

    localStorage: {},
    accessCredential: {}
  }),

  watch: {
  }, 

  methods: {
    async selectTokenFromTokenView(){
      const selectTokenFromTokenViewRequetQuery =
      {
        'startDate': this.input.startDate,
        'endDate': this.input.endDate
      };
      const selectTokenFromTokenViewResult = await this.$generalFunctions.default.methods.executeHttpPostRequest('/agent/token/functions/selectTokenFromTokenView', selectTokenFromTokenViewRequetQuery);
      if (selectTokenFromTokenViewResult.success){
        this.display.token = selectTokenFromTokenViewResult.result;
        this.loader.selectTokenFromTokenView = false;
      } else {
        this.$root.notificationDialog.showNotificationDialog({
          'notificationDialogTitle': 'ERROR',
          'notificationDialogBody': 'Ha ocurrido un error inesperado al consultar la lista de tokens, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema',
          'notificationDialogColor': 'error',
          'notificationDialogIsPersistent': false
        });
      }
    }
  },

  async mounted(){
    await this.selectTokenFromTokenView();
  }
});
</script>
